<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Demande de véhicule</span>
        <h3 class="page-title">{{ "Pour " + user.firstName  + " " + user.lastName}}</h3>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col">
        <div
          class="card card-small mb-4 mt-3"
          v-if="loading || !user.connected"
        >
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <template v-else>
          <step-one v-if="step === 1" :user.sync="user" @input="handleStepOne" @isExternalClient="getIsExternalClient"/>
          <step-two v-if="step === 2" :user.sync="user" @input="handleStepTwo" @isExternalClient="getIsExternalClient"/>
          <step-three
            v-else-if="step === 3"
            :user.sync="user"
            :isExternalClient="isExternal"
            @input="handleStepThree"
          />
          <step-four
            v-else-if="step === 4"
            :user.sync="user"
            :request="request"
            @input="handleStepFour"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import StepOne from "../../components/minibus/minibusRequest/StepOne.vue";
import StepTwo from "../../components/minibus/minibusRequest/StepTwo.vue";
import StepThree from "../../components/minibus/minibusRequest/StepThree.vue";
import StepFour from "../../components/minibus/minibusRequest/StepFour.vue";

export default {
  name: "minibusRequest",
  components: {
    StepFour,
    StepThree,
    StepTwo,
    StepOne,
    SpinnerDot
  },
  data() {
    return {
      request: {},
      step: 1,
      loading: false,
      isExternal: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    }
  },

  methods: {
    handleStepOne(){
      if (this.$store.state.user.informations.permissions[0].groupReference == "_receptionist") {
        this.step = 2
      } else {
        this.step = 3
      }
    },
    handleStepTwo(answer) {
      if (!answer) {
        this.step = 1;
      } else {
        this.step = 3;
      }
    },
    handleStepThree(answer) {
      if (!answer) {
        if (this.$store.state.user.informations.permissions[0].groupReference == "_receptionist") {
          this.step = 2;
        } else {
          this.step = 1;
        }
      } else {
        this.request = answer;
        this.step = 4;
      }
    },

    handleStepFour(answer) {
      if (!answer) {
        this.step = 3;
      } else {
        this.loading = true;
        this.$services.minibusRequest.createRequest(this.request).then((res) => {
          this.loading = false;
          this.$miniToastr.success(this.$t("minibus.request.success"));
          this.$router.push("/demandes/historique");   
        })
        .catch(error => {
          this.$miniToastr.error("Une erreur s'est produite."); 
        });
      }
    },
    getIsExternalClient(data) {
      this.isExternal = data;
    }
  }
};

</script>

<style lang="scss" scoped>
.main-content > .main-content-container.container-fluid {
  min-height: calc(100vh - #{3.75rem + 3.75rem});
  // @media screen and (min-width: 320px) and (max-width: 767px) {
  //   height: 910px;
  // }
}
</style>
